'use client';
import clsx from 'clsx';
import dynamic from 'next/dynamic';
import { useDropdownContext } from '../../../DropdownProvider';
import { FullscreenOverlay } from '../../../FullscreenOverlay';
import { MyNerdWalletButtonDesktop } from './MyNerdWalletButtonDesktop';
import { MyNerdWalletButtonMobile } from './MyNerdWalletButtonMobile';
import { useMyNerdWalletHoverEventCallbacks } from './hooks';

const MyNerdWalletDropdown = dynamic(
  () => import('./MyNerdWalletDropdown').then(module => module.MyNerdWalletDropdown),
  { ssr: false },
);

export function MyNerdWalletMenu() {
  const {
    state: {
      myNerdWalletMenu: { isOpen },
    },
  } = useDropdownContext();

  const { handleCloseMenu } = useMyNerdWalletHoverEventCallbacks();

  return (
    <div
      className={clsx(
        'flex',
        'items-center',
        'justify-center',
        'bg-transparent',
        'border-0',
        'focus:outline-2',
        'focus:outline-offset-4',
      )}
    >
      <FullscreenOverlay isOpen={isOpen} onMouseEnter={handleCloseMenu} />
      <MyNerdWalletButtonDesktop />
      <MyNerdWalletButtonMobile />
      <MyNerdWalletDropdown />
    </div>
  );
}
